import React, { useState } from 'react'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import FeedbackTextarea from './FeedbackTextarea'
import '../../styles/FeedbackModule/FeedbackModule.scss'

const ratings = [1, 2, 3, 4, 5] as const
type RatingsOrNull = typeof ratings[number] | null

const question = 'How would you rate your experience using SmartAsset’s financial advisor matching service so far?'

const FeedbackModule = () => {
  const { state: { pageKey } } = useMatchScreen()
  const [showTextarea, setShowTextarea] = useState(false)
  const [selectedValue, setSelectedValue] = useState<RatingsOrNull>(null)
  const [showThanks, setShowThanks] = useState(false)
  const [showFeedbackModule, setShowFeedbackModule] = useState(true)

  const handleButtonClick = (value: RatingsOrNull) => {
    setShowTextarea(true)
    setSelectedValue(value)

    trackEvent('FeedbackModule', 'CSAT Vote', {
      page_key: pageKey,
      vote: value,
      question
    })
  }

  const showThanksMessage = () => {
    setShowFeedbackModule(false)
    setShowThanks(true)
  }

  return (
        <div className={`share_feedback_wrapper ${!showFeedbackModule ? 'hidden' : ''}`}>
            <div className="share_feedback">
                <div className="share_feedback_left">
                    <h2>Share Your Feedback</h2>
                    <p>
                        How would you rate your experience using SmartAsset’s financial advisor matching service so far?
                    </p>
                </div>
                <div className="share_feedback_right">
                    <div className="feedback_buttons">
                        {ratings.map((value) => (
                            <button
                                key={value}
                                onClick={() => handleButtonClick(value)}
                                className={selectedValue === value ? 'selected' : ''}
                            >
                                {value}
                            </button>
                        ))}
                    </div>
                    <div className="button_labels">
                        <span>Needs Improvement</span>
                        <span>Excellent</span>
                    </div>
                </div>
            </div>

            {showTextarea && (
                <FeedbackTextarea
                    question={question}
                    onThanksMessage={showThanksMessage}
                    expanded={showTextarea}
                />
            )}

            <div className={`thanks_message ${showThanks ? 'thanks_message_visible' : ''}`}>
                <p>Thank you for your answer! Your feedback is very important to us.</p>
            </div>
        </div>
  )
}

export default FeedbackModule
